import React, { useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Brain } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import './IntelligenceAuth.css';
import { authDestination } from '../lib/authDestination';

// Handles the return leg of Emergent Google sign-in: exchanges #session_id for an app JWT.
const GoogleAuthCallback = () => {
  const hasProcessed = useRef(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { loginWithGoogleSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const params = new URLSearchParams(location.hash.replace(/^#/, ''));
    const sessionId = params.get('session_id');
    // Drop the fragment so the session_id is never reused or leaked via history
    window.history.replaceState(null, '', window.location.pathname + window.location.search);

    const run = async () => {
      try {
        if (!sessionId) throw new Error('missing session');
        await loginWithGoogleSession(sessionId);
        const returnTo = sessionStorage.getItem('crescent-auth-return');
        sessionStorage.removeItem('crescent-auth-return');
        navigate(authDestination(`?returnTo=${encodeURIComponent(returnTo || '/intelligence')}`), { replace: true });
      } catch (err) {
        navigate('/intelligence/auth', {
          replace: true,
          state: { error: err.response?.data?.detail || 'Google sign-in failed. Please try again.' },
        });
      }
    };
    run();
  }, [location.hash, loginWithGoogleSession, navigate]);

  return (
    <div className="intelligence-auth-page" data-testid="google-auth-callback">
      <div className="auth-background">
        <div className="auth-gradient-1" />
        <div className="auth-gradient-2" />
        <div className="auth-grid" />
      </div>
      <div className="auth-callback-status">
        <div className="brand-icon"><Brain size={28} /></div>
        <span className="loading-spinner" />
        <p>Signing you in with Google…</p>
      </div>
    </div>
  );
};

export default GoogleAuthCallback;
